import { SubmissionError } from 'redux-form';

/**
 * Process Axios error and throw a meaningful ReduxForm SubmissionError
 * @param  {[type]} e Exception caught from Axios
 * @throws {SubmissionError}
 */
const throwSubmissionErrorFromAxiosError = e => {
  let errorDetail;
  if (e.response) {
    errorDetail = e.response.data;
  } else if (e.request) {
    errorDetail = { _error: 'Connection failed.' };
  } else {
    errorDetail = { _error: 'An error occurred.' };
  }

  throw new SubmissionError(errorDetail);
}

export default throwSubmissionErrorFromAxiosError;



// WEBPACK FOOTER //
// ./src/modules/misc/lib/throwSubmissionErrorFromAxiosError.js